import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { format } from 'date-fns'

import { logo } from '../../images/images.js'
import pirTerminology from '../../util/pirTerminology'

import { FlexColumn, Divider, MedBGContainer, SpaceBetweenRowContainer } from '../styles/Containers.js'
import { BoldBodyText, SmallBodyText } from '../styles/Text'
import DetailSection from '../common/DetailSection.js'

const FormContainer = styled(MedBGContainer)`
  display: flex;
  align-items: ${props => (!props.details ? 'center' : 'flex-start')};
  gap: 30px;
  padding: 30px;
  text-align: left;

  @media only screen and (max-width: 1000px) {
    padding: 25px;
  }
`

const TotalContainer = styled(SpaceBetweenRowContainer)`
  @media only screen and (max-width: 1000px) {
    flex-wrap: wrap;
  }
`

const Total = styled(BoldBodyText)`
  font-size: 25px;
`

const Logo = styled.img`
  width: 80px;
  max-height: 80px;
`

function OrderSummary({
  displayDetails = true,
  details = {},
  amount = '47.25',
  title = pirTerminology.getRequestName(),
  subtitle = 'Document Access',
  paymentDueDate
}) {
  const totalDueLabel = paymentDueDate ? `Total due ${format(paymentDueDate, 'MMM-dd-yyyy')}` : 'Total due'
  return (
    <FlexColumn width="100%" gap="15px">
      <FormContainer details={displayDetails}>
        <Logo src={logo} />
        <FlexColumn width="100%">
          <SpaceBetweenRowContainer>
            <FlexColumn gap="5px">
              <BoldBodyText>{title}</BoldBodyText>
              {subtitle && <SmallBodyText>{subtitle}</SmallBodyText>}
            </FlexColumn>
            <BoldBodyText>${amount}</BoldBodyText>
          </SpaceBetweenRowContainer>
          {displayDetails && (
            <>
              <Divider />
              <DetailSection details={details} />
            </>
          )}
        </FlexColumn>
      </FormContainer>
      <Divider />
      <TotalContainer gap="10px 15px">
        <BoldBodyText>{totalDueLabel}</BoldBodyText>
        <Total>${amount} CAD</Total>
      </TotalContainer>
    </FlexColumn>
  )
}

OrderSummary.propTypes = {
  displayDetails: PropTypes.bool,
  details: PropTypes.object.isRequired,
  amount: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  paymentDueDate: PropTypes.instanceOf(Date)
}
export default OrderSummary
